import {SetProperties} from "@/models/SetProperties";
import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import { formatDate2ToText } from '@/scripts'

export class ApplicationParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(Application.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    index >=0 && this.list.splice(index, 1, Application.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)) || el.id === item.id)
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => Application.build(el))
    }
    return this
  }
}

export class Application extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.submissionSession = null
    this.personalData = null
    this.applicationType = null
    this.specialityFrom = null
    this.specialityTo = null
    this.courseNumberFrom = null
    this.courseNumberTo = null
    this.group = null
    this.organizationFrom = null
    this.organizationNameFrom = null
    this.paidFormTo = null
    this.paidFormFrom = null
    this.educationFormTo = null
    this.educationFormFrom = null
    this.expirationReason = null
    this.expirationDate = null
    this.applicationStatus = null
    this.curator = null
    this.createDate = null
    this.sendDateTime = null
    this.testScore = null
    this.averageScore = null
    this.achievementList = []
    this.educationList = []
    this.identityCardList = []
    this.medicalCertificateList = []
    this.militaryList = []
    this.trainingCertificateList = []

    this.messages = []
    this.fullName = null
    this.email = null
    this.phoneNumber = null
  }

  get getFullName() {
   return this.personalData?.personalNameList.length ? this.personalData.personalNameList[0].fullName : ''
  }

  get getSendDateTimeText() {
    return this.sendDateTime ? formatDate2ToText(this.sendDateTime) : ''
  }

  getForAPI() {
    return {
      id: this.id,
      submissionSession: this.submissionSession,
      personalData: this.personalData,
      applicationType: this.applicationType,
      specialityFrom: this.specialityFrom,
      specialityTo: this.specialityTo,
      courseNumberFrom: this.courseNumberFrom,
      courseNumberTo: this.courseNumberTo,
      group: this.group,
      organizationFrom: this.organizationFrom,
      organizationNameFrom: this.organizationFrom?.name || this.organizationNameFrom,
      paidFormTo: this.paidFormTo,
      paidFormFrom: this.paidFormFrom,
      educationFormTo: this.educationFormTo,
      educationFormFrom: this.educationFormFrom,
      expirationReason: this.expirationReason,
      expirationDate: this.expirationDate,
      applicationStatus: this.applicationStatus,
      curator: this.curator,
      createDate: this.createDate,
      sendDateTime: this.sendDateTime,
      testScore: this.testScore,
      averageScore: this.averageScore,
      achievementList: this.achievementList,
      educationList: this.educationList,
      identityCardList: this.identityCardList,
      medicalCertificateList: this.medicalCertificateList,
      militaryList: this.militaryList,
      trainingCertificateList: this.trainingCertificateList,
    }
  }

  static build(obj) {
    const _this = new Application()
    if (obj) {
      _this.id = obj.id
      _this.submissionSession = obj.submissionSession
      _this.personalData = obj.personalData
      _this.applicationType = obj.applicationType
      _this.specialityFrom = obj.specialityFrom
      _this.specialityTo = obj.specialityTo
      _this.courseNumberFrom = obj.courseNumberFrom
      _this.courseNumberTo = obj.courseNumberTo
      _this.group = obj.group
      _this.organizationFrom = obj.organizationFrom
      _this.organizationNameFrom = obj.organizationNameFrom
      _this.paidFormTo = obj.paidFormTo
      _this.paidFormFrom = obj.paidFormFrom
      _this.educationFormTo = obj.educationFormTo
      _this.educationFormFrom = obj.educationFormFrom
      _this.expirationReason = obj.expirationReason
      _this.expirationDate = obj.expirationDate
      _this.applicationStatus = obj.applicationStatus
      _this.curator = obj.curator
      _this.createDate = obj.createDate
      _this.sendDateTime = obj.sendDateTime
      _this.testScore = obj.testScore
      _this.averageScore = obj.averageScore
      _this.achievementList = obj.achievementList
      _this.educationList = obj.educationList
      _this.identityCardList = obj.identityCardList
      _this.medicalCertificateList = obj.medicalCertificateList
      _this.militaryList = obj.militaryList
      _this.trainingCertificateList = obj.trainingCertificateList
      _this.messages = obj.messages
      _this.fullName = obj.fullName
      _this.email = obj.email
      _this.phoneNumber = obj.phoneNumber
    }
    return _this
  }
}
